import startEnv from '~/env'
import React, { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux'
import { Router } from 'react-router-dom'

import Routes from '~/routes'
import history from '~/services/history'
import { store, persistor } from '~/store'
import ModalAlert from '~/components/modal-alert'
import { IntlProvider } from 'react-intl'

import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/core/styles'

import * as Themes from '~/assets/styles'
import * as Languages from '~/assets/languages'

import 'react-toastify/dist/ReactToastify.css'

function App () {
  const [loadEnvs, setLoadEnvs] = useState({})

  const {
    NODE_ENV,
    REACT_APP_BRANCH = 'BOT'
  } = window?.env || {}

  useEffect(() => {
    if (!NODE_ENV && typeof loadEnvs?.code === 'undefined') {
      startEnv(setLoadEnvs)
    }
  }, [loadEnvs, NODE_ENV])

  const language = 'pt-BR'

  return (
    <>
      {loadEnvs?.code === 0 && (
        <h1>{loadEnvs?.msg}</h1>
      )}

      {loadEnvs?.code === 1 && (
        <Provider store={store}>
          <ThemeProvider theme={Themes[REACT_APP_BRANCH]}>
            <CssBaseline />
            <PersistGate persistor={persistor}>
              <IntlProvider messages={Languages[language.replace('-', '')]} locale={language} defaultLocale={language}>
                <Router history={history}>
                  <Routes />
                  <ToastContainer autoClose={3000} />
                </Router>
              </IntlProvider>
            </PersistGate>
            <ModalAlert />
          </ThemeProvider>
        </Provider>
      )}
    </>
  )
}

export default App
